module.exports = __webpack_public_path__ + "flyer_background_pumpkin_three_064-7c84f1b6d41cd658414d64232348c6f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_pumpkin_three_064.jpg
// module id = 1679
// module chunks = 1